const outOfRegionPageTranslations = {
  title: "Out Of Region",
  descriptionLine1: "You have a local subscription but are currently trying to access the portal from outside Egypt.",
  descriptionLine2: "This subscription type is limited to local access.",
  button: "Back to Sign In",
};

export default outOfRegionPageTranslations;
